import { SET_LOADING_VALUE } from "../actions/networkActions";

export default function(state = { questionnaire_pages: {} }, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_LOADING_VALUE:
      return {
        ...state,
        [payload.target]: {
          ...state[payload.target],
          [payload.id]: {
            ...state[payload.target][payload.id],
            loading: payload.loading,
            saved: payload.saved
          }
        }
      };
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/networkReducer.js